<template>
  <div class="testInfo">
    <div class="part" style="text-align:center;" v-if="info.length==0">暂无检测信息</div>
    <div class="part" v-for="(item,index) in info" :key="index" v-else>
      <div><span>检测项目：</span><span>{{item.itemna_name}}</span></div>
      <div><span>检测数据：</span><span>{{item.check_value}}{{item.check_value_unit}}</span></div>
      <div><span>检测结果：</span><span :style="{color:item.result==1?'#33D179':'#EE3D3D'}">{{item.result==1?'合格':'不合格'}}</span></div>
      <div><span>检测员：</span><span>{{item.realname}}</span></div>
      <div><span>检测日期：</span><span>{{item.check_time}}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'testInfo',
  data(){
    return {
      info:[]
    }
  },
  created(){
    this.info = JSON.parse(this.$route.query.info)
  },
  mounted(){

  },
  methods:{
    
  }
}
</script>

<style lang="less" scoped>
.testInfo{
  background-color: #f5f5f5;
  min-height: 100%;
  overflow: hidden;
  .part{
    width: 6.5rem;
    margin: 0.2rem auto 0;
    background: #fff;
    border-radius: 0.1rem;
    padding: 0.1rem 0.2rem;

    >div{
      line-height: 0.61rem;
      display: flex;
      justify-content: space-between;
      font-size: 0.32rem;
      >span:first-child{
        color: #333;
        min-width: 1.28rem;
      }
      >span:last-child{
        color: #666;
        flex-grow: 1;
        text-align: right;
      }
    } 
  }
}
</style>